import { render, staticRenderFns } from "./EditCourseOverview.vue?vue&type=template&id=274e4c0d&scoped=true&"
import script from "./EditCourseOverview.vue?vue&type=script&lang=js&"
export * from "./EditCourseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e4c0d",
  null
  
)

export default component.exports